<template>
    <div class="row">
      <div class="col-md-8">
        <card>
          <form class="form-horizontal" @submit.prevent="updateItem">
            <h5 slot="header" class="card-title ml-7">
              Edit Room Drink
            </h5>
            <br>
            <div class="row">
            <div class="col-md-3">
                <label class="col-md-3 col-form-label">Status</label>
            </div>
             <div class="col-9">
                <p-switch v-model="active" @update:model-value="updateActiveStatus"></p-switch>

             </div>
              <br>
              <label class="col-md-3 col-form-label">Drink Name</label>
              <div class="col-md-9">
                <fg-input
                  v-model="form.DrinkName"
                  placeholder="Name"
                  type="text"
                  required
                  :readonly="true"
                ></fg-input>
              </div>
  
              <label class="col-md-3 col-form-label">Drink Type</label>
              <div class="col-md-9">
                <fg-input>
                  <el-select class="select-info"
                             size="large"
                             placeholder="Drink Type"
                             v-model="form.DrinkType">
                    <el-option v-for="option in selects.drink"
                               class="select-info"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>
  
              <label class="col-md-3 col-form-label">Drink Ingredients</label>
              <div class="col-md-9">
                <textarea class="form-control mb-2" v-model="form.DrinkIngredients" placeholder="Drink Ingredients" rows="3"></textarea>
              </div>
  
              <label class="col-md-3 col-form-label">Drink Price</label>
              <div class="col-md-9">
                <fg-input v-model="form.DrinkPrice" placeholder="Price" type="number" step="any"></fg-input>
              </div>  
            </div>  
  
            <!-- <div class="row mb-3">
              <label class="col-md-3 col-form-label">Upload Image</label>
              <div class="col-md-9">
                <label for="imageUpload" class="img">
                  <span v-if="!imageUrl">Choose Image</span>
                  <img v-if="!imageUrl" src="../../../../../public/static/img/drink.jpg" width="200" alt="">
                  <input type="file" id="imageUpload" @change="onFileChange" accept="image/*" hidden />
                </label>
  
                <div v-if="imageUrl" class="mt-3">
                  <img :src="imageUrl" alt="Preview" class="img-thumbnail" style="max-width: 300px;" />
                  <br>
                  <p-button type="info outline mt-2" @click="removeImage" outline>
                    <i slot="label" class="nc-icon nc-simple-remove"></i> Delete Image
                  </p-button>
                </div>
              </div>
            </div> -->
  
            <div slot="footer" class="row">
              <label class="col-md-3"></label>
              <div class="col-md-9 d-flex justify-content-end">
                <p-button type="success" round @click="updateItem" :disabled="isSubmitting">
                  Update Drink
                </p-button>
                <p-button type="danger" round @click="deleteItem" class="ml-2">
                Delete Drink
              </p-button>
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
  </template>
  
  <script>
  import { Select, Option} from 'element-ui'
  import { Card } from 'src/components/UIComponents';
  import {Button} from 'src/components/UIComponents';
  import Swal from 'sweetalert2';

  import { doc, getDoc, getDocs, collection, setDoc, deleteDoc, query, where, orderBy } from "firebase/firestore"; // Import necessary Firestore functions
  import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage"; // Firebase storage functions
  import { db } from "@/firebase"; // Firestore instance
  import { storage } from "@/firebase"; // Firebase storage instance
  import PSwitch from 'src/components/UIComponents/Switch.vue'

  export default {
    components: {
      PSwitch,
      [Button.name]: Button,
      Card,
      [Option.name]: Option,
      [Select.name]: Select,
    },
    data() {
      return {
        isSubmitting: false,
        imageUrl: null,
        active: true,
        form: {
          DrinkName: '',
          DrinkType: '',
          DrinkIngredients: '',
          DrinkPrice: '',
          DrinkType: ''
        },
        selects: {
          simple: '',
          drink: []
        }
      };
    },
    watch: {
    // Watch for changes in the switches.defaultOn value
    async 'active'(newValue) {
        console.log("Active status:", this.active);

      try {
        // Reference to the document you want to update
        const docRef = doc(db, "DrinksMenuRoom", this.form.DrinkName); // Replace with the correct document ID

        // Update the 'active' field based on the switch state
        await setDoc(docRef, { active: newValue }, { merge: true });

        console.log(`Document updated with active: ${newValue}`);
      } catch (error) {
        console.error("Error updating status:", error.message);
      }
     }
    },
    async mounted() {
      this.fetchCategories();
      const { id } = this.$route.params;
      if (id) {
        // Fetch the item data from Firestore using the DrinkName (id)
        const docRef = doc(db, "DrinksMenuRoom", id);
        const docSnap = await getDoc(docRef);
  
        if (docSnap.exists()) {
          const data = docSnap.data();
          this.form = { ...data };
          this.active = data.active; // Set the active status
        //   this.imageUrl = data.PictureURL; // Set image preview URL
          this.selects.simple = data.DrinkType; // Set the selected Drink type
        } else {
          alert("No such document!");
        }
      }
    },
    methods: {
      async fetchCategories() {
        try {
          const q = query(
            collection(db, "CategoryOptions"),
            where("type", "==", "RoomDrink")
          );
          const querySnapshot = await getDocs(q);
          const options = querySnapshot.docs.map(doc => ({
            value: doc.data().name,
            label: doc.data().name
          }));
          this.selects.drink = options.sort((a, b) => a.label.localeCompare(b.label));
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      },
      onFileChange(event) {
        const file = event.target.files[0];
        if (file) {
          this.file = file;
          this.imageUrl = URL.createObjectURL(file);
        }
      },
      removeImage() {
        this.imageUrl = null;
        this.file = null;
      },
      async updateItem() {
        try {
          this.isSubmitting = true;
  
        //   let updatedImageUrl = this.imageUrl;
  
        //   if (this.file) {
        //     // Upload the new image to Firebase Storage if there's a new one
        //     const storageRef = ref(storage, `drinkImages/${this.file.name}`);
        //     const snapshot = await uploadBytes(storageRef, this.file);
        //     updatedImageUrl = await getDownloadURL(snapshot.ref);
        //   }
  
          // Update the Firestore document using the DrinkName (id)
          const docRef = doc(db, "DrinksMenuRoom", this.form.DrinkName);
          await setDoc(docRef, {
            DrinkName: this.form.DrinkName,
            DrinkType: this.form.DrinkType,
            active: this.active,
            DrinkIngredients: this.form.DrinkIngredients,
            DrinkPrice: this.form.DrinkPrice,
            // PictureURL: updatedImageUrl, // Store the image URL
            createdAt: new Date()
          });
        //   console.log("Image  ", updatedImageUrl);

          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          }).fire({
            title: `Success!`,
            text: "Drink item updated successfully!",
          });
  
          this.$router.push("/roomdrink/list");
          this.isSubmitting = false;
        } catch (error) {
          console.error('Error updating menu:', error.message);
          alert('Error: ' + error.message);
        }
      },
      async deleteItem() {
        const swalWithBootstrapButtons4 = Swal.mixin({
            customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        });

        // Display the confirmation dialog
        swalWithBootstrapButtons4
            .fire({
            title: "Are you sure?",
            text: `You won't be able to revert this!`,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            showCancelButton: true,
            })
            .then(async (result) => {
            if (result.value) {
                try {
                // Delete the document from Firestore
                const docRef = doc(db, "DrinksMenuRoom", this.form.DrinkName);
                await deleteDoc(docRef);

                // If an image exists, delete it from Firebase Storage
                // if (this.imageUrl) {
                //     if (this.file && this.file.name) {
                //     const storageRef = ref(storage, `drinkImages/${this.file.name}`);
                //     await deleteObject(storageRef);
                //     }
                // }

                // Success message after deletion
                const swalWithBootstrapButtons5 = Swal.mixin({
                    customClass: {
                    confirmButton: "btn btn-success",
                    },
                    buttonsStyling: false,
                });

                swalWithBootstrapButtons5.fire({
                    title: "Deleted!",
                    text: "Your file has been deleted.",
                });

                // Redirect to the list page after deletion
                this.$router.push("/roomdrink/list");
                } catch (error) {
                console.error('Error deleting menu:', error.message);
                alert('Error: ' + error.message);
                }
            }
            });
        },
    async updateActiveStatus() {
        console.log("Active status:", this.active);
      try {
        // Reference to the document you want to update
        const docRef = doc(db, "DrinksMenuRoom", this.form.DrinkName); // Replace with the correct document ID

        // Update the 'active' field based on the switch state
        await setDoc(docRef, { active: this.active }, { merge: true });

        // Log success or display a message
        console.log(`Document updated with active: ${this.active}`);
      } catch (error) {
        console.error("Error updating status:", error);
      }
    },

    }
  };
  </script>
  


